/* eslint-disable react/require-default-props */
import React, { ReactElement, ReactNode } from 'react';

import { FieldError } from 'react-hook-form';

import { FormItem } from 'elmo-elements';

interface FormItemWrapperPropsType {
  id?: string;
  className?: string;
  children: ReactNode;
  label?: string;
  yupFieldError: FieldError | undefined;
}

const FormItemWrapper = ({
  id,
  className,
  children,
  label,
  yupFieldError,
}: FormItemWrapperPropsType): ReactElement => (
  <FormItem
    id={id}
    className={className}
    label={label}
    message={yupFieldError?.message}
    status={yupFieldError ? 'error' : 'default'}
  >
    {children}
  </FormItem>
);

export default FormItemWrapper;
